module.exports = __webpack_public_path__ + "static/media/web_655_logo_n-logo.190ad07a.png";